import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue, TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import { findReplyByQuestionId, getReplyValue, getFieldValue, toDateFormat } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'
import { usePlace } from '../../_load/PlaceLoader'

const Content = ({ templateId }) => {
  const { endDate: parentEndDate } = useParentServiceOrder()
  const place = usePlace()
  const { replies, endDate } = useServiceOrder()

  // const nomeEmpresa = getReplyValue(findReplyByQuestionId(parentReplies, 1387))
  const nomeEmpresa = getFieldValue(place.fieldValues, 'Nome da empresa').value
  const enderecoEmpresa = getFieldValue(place.fieldValues, 'Endereço da empresa').value.search.replace(
    'Brazil',
    'Brasil'
  )

  const CNPJ = getFieldValue(place.fieldValues, 'CNPJ').value
  const nomeRepresentante = place.name
  const enderecoRepresentante = getFieldValue(place.fieldValues, 'Endereço').value.search.replace('Brazil', 'Brasil')
  const CPF = getFieldValue(place.fieldValues, 'CPF').value
  const dataRescisao = toDateFormat(parentEndDate, 'DD/MM/YYYY')

  const parcelas = getReplyValue(findReplyByQuestionId(replies, 1418))
  const valor = getReplyValue(findReplyByQuestionId(replies, 1349))
  const valorPorExtenso = getReplyValue(findReplyByQuestionId(replies, 1417))
  const pagamentoPrimeiraParcela = toDateFormat(getReplyValue(findReplyByQuestionId(replies, 1419)), 'DD/MM/YYYY')
  const diaMes = getReplyValue(findReplyByQuestionId(replies, 1420))

  const geracaoContrato = toDateFormat(endDate, 'DD/MM/YYYY')

  return (
    <View style={{ width: '95%' }} pageBreakAfter>
      <Text align="justify">
        De um lado <b>Btime Soluções LTDA</b>, com sede na Alameda Vicente Pinzon, 54, na cidade de São Paulo, Estado de
        São Paulo, CEP 04547-130, inscrita no CNPJ/MF sob número 21.849.504-0001/50, representada nos termos de seu
        Contrato Social, doravante denominada CONTRATANTE, e de outro lado, {nomeEmpresa}, {enderecoEmpresa}, inscrita
        no CNPJ/MF sob número {CNPJ}, representada por {nomeRepresentante}, inscrito no CPF/MF sob n° {CPF}, residente e
        domiciliado à {enderecoRepresentante} doravante denominada CONTRATADA, mediante as cláusulas e condições
        seguintes:
        <Separator weight={4} />
        Rescisão amigável: O presente termo tem por objeto a rescisão do Contrato de Prestação de Serviços, celebrado em{' '}
        {dataRescisao}. As partes resolvem de livre e comum acordo, RESCINDIR, amigavelmente, o referido contrato, nada
        mais tendo a reclamar uma da outra, independentemente da natureza da obrigação, a qualquer título e em qualquer
        época, relativamente às obrigações assumidas no ajuste ora rescindido.
        <Separator weight={4} />
        Total quitação: As partes transacionaram livremente a rescisão ocorrida e está se dará, com o pagamento dos
        seguintes valores à CONTRATADA: (i) {parcelas} parcelas de R${valor} ({valorPorExtenso}), sendo a primeira
        parcela paga no dia {pagamentoPrimeiraParcela} e as subsequentes todo dia {diaMes} do mês.
        <Separator weight={4} />
        Os pagamentos à CONTRATADA serão realizados mediante emissão e envio prévio da Nota Fiscal pela CONTRATADA para
        a CONTRATANTE - com atédias úteis de antecedência da data para pagamento das parcelas acima mencionadas.
        <Separator weight={4} />
        Após o recebimento das referidas importâncias, as partes de mútuo e comum acordo, dão entre si, plena, total e
        irrevogável quitação quanto ao objeto contratado, para nada mais reclamarem.
        <Separator weight={4} />
        Geral: As partes elegem o Foro da Comarca de São Paulo/SP para dirimir quaisquer dúvidas acerca do presente
        instrumento, desprezados quaisquer outros, por mais privilegiados que se apresentem.
        <Separator weight={4} />
        A CONTRATADA declara ter lido, entendido e estar de acordo com o disposto neste Termo de Rescisão Contratual.
        <Separator weight={4} />
        <Text size="small" align={'center'}>
          São Paulo, {geracaoContrato}
        </Text>
        <Separator weight={40} />
        <Table color={'transparent'} width={'100%'}>
          <TableCol color={'transparent'} width={'50%'}>
            <Table color={'transparent'} width={'100%'}>
              <TableRow>
                <Text size="small" />
              </TableRow>
              <TableRow color={'transparent'}>
                <Text size="small" align={'center'}>
                  CONTRATANTE
                </Text>
              </TableRow>
              <TableRow color={'transparent'}>
                <Text size="small" bold align={'center'}>
                  BRUNO GOLNÇALVES D'ATTILIO
                </Text>
              </TableRow>
            </Table>
          </TableCol>
          <TableCol color={'transparent'} width={'50%'}>
            <Table color={'transparent'} width={'100%'}>
              <TableRow>
                <Text size="small" />
              </TableRow>
              <TableRow color={'transparent'}>
                <Text size="small" align={'center'}>
                  CONTRATADA
                </Text>
              </TableRow>
              <TableRow color={'transparent'}>
                <Text size="small" align={'center'}>
                  {nomeEmpresa}
                </Text>
              </TableRow>
            </Table>
          </TableCol>
        </Table>
      </Text>
    </View>
  )
}

export default Content
